import { render, staticRenderFns } from "./paid-voice.vue?vue&type=template&id=3c08b55a&scoped=true&"
import script from "./paid-voice.vue?vue&type=script&lang=js&"
export * from "./paid-voice.vue?vue&type=script&lang=js&"
import style0 from "./paid-voice.vue?vue&type=style&index=0&id=3c08b55a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c08b55a",
  null
  
)

export default component.exports